import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ExpressCheckout } from './types';

export const expressCheckoutSliceReducer = createSlice({
  name: 'expressCheckout',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<ExpressCheckout>) => {
      state.data = action.payload;
    },
    clear: state => {
      state.data = null;
    },
  },
});

export const { set: setExpressCheckout, clear: clearExpressCheckout } =
  expressCheckoutSliceReducer.actions;
export default expressCheckoutSliceReducer.reducer;
